/**
 * Transforms a single log element into table row format
 * @param {Object} element - Log element from API
 * @param {number} index - Index for serial number
 * @returns {Object} Transformed log object
 */
export const transformLogItem = (element, index) => {
    const rawDate = element.created_at;
    const timestamp = rawDate ? new Date(rawDate).getTime() : null;

    return {
        id: index + 1,
        stack: element.stack,
        url: element.url ? element.url.split('?')[0] : 'N/A',
        msg: element.message,
        date: rawDate?.split('T')[0] || 'N/A',
        __date_sort: Number.isFinite(timestamp) ? timestamp : 0
    };
};

/**
 * Transforms array of logs into DataTable format
 * @param {Array} logs - Array of log objects from API
 * @param {Array} columns - Table column configuration
 * @returns {Object} DataTable formatted object with columns and rows
 */
export const transformLogsToTableData = (logs, columns) => {
    const log_list = logs
        .map((element, index) => transformLogItem(element, index))
        .sort((a, b) => (b.__date_sort ?? 0) - (a.__date_sort ?? 0));

    return {
        columns,
        rows: log_list,
    };
};

/**
 * Extracts date from ISO string
 * @param {string} dateString - ISO date string
 * @returns {string} Date in YYYY-MM-DD format
 */
export const extractDate = (dateString) => {
    return dateString?.split('T')[0] || 'N/A';
};

/**
 * Cleans URL by removing query parameters
 * @param {string} url - Full URL string
 * @returns {string} Cleaned URL without query params
 */
export const cleanUrl = (url) => {
    return url ? url.split('?')[0] : 'N/A';
};

